import React from "react";
import LogoSvg from "../../../assets/logo";
import styles from "./leftbar.module.css"

import {HiOutlinePhotograph} from "react-icons/hi"
import {AiOutlinePlayCircle,AiOutlineLink,AiOutlineTag,AiOutlineBarChart,AiOutlineSave} from "react-icons/ai"
import IconList from "./iconsList";

const MiniLeftBar = ()=>{
    return (
        <div className={styles.miniContainer}>
            <div className={styles.logoConatiner}>
            <LogoSvg width="50px" color="white"/>
           </div>
           <div className={styles.miniIcon}>
           <IconList/>
           </div>
            </div>
      
        )
}

export default MiniLeftBar